import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Link, FileText, MessageSquare, ArrowRight, Globe, Palette, Image, Eye, RefreshCw, Brush, Smartphone, Share2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import NPOMicrosite from '@/pages/npo/NPOMicrosite';
import MissionHubContentPage from '@/pages/npo/mission-hub/MissionHubContentPage';

const MyWebsitePage = ({ session, profile }: { session: any; profile: any }) => {
  const navigate = useNavigate();

  const actionCards = [
    {
      title: 'Setup & Design',
      description: 'Configure your website settings and customize the design',
      icon: <Palette className="h-8 w-8" />,
      color: 'bg-pink-500',
      path: '/dashboard/mission-hub/setup'
    },
    {
      title: 'Manage Content',
      description: 'Create and edit your website content and pages',
      icon: <MessageSquare className="h-8 w-8" />,
      color: 'bg-blue-500',
      path: '/dashboard/mission-hub/content'
    }
  ];

  const websiteFeatures = [
    {
      title: 'Mobile Responsive',
      description: 'Your website looks great on all devices',
      icon: <Globe className="h-6 w-6" />
    },
    {
      title: 'Custom Domain',
      description: 'Connect your own domain name',
      icon: <Link className="h-6 w-6" />
    },
    {
      title: 'Media Gallery',
      description: 'Showcase your impact with photos and videos',
      icon: <Image className="h-6 w-6" />
    },
    {
      title: 'SEO Optimized',
      description: 'Get discovered by supporters online',
      icon: <Eye className="h-6 w-6" />
    }
  ];

  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">My Microsite</h1>
        <p className="text-muted-foreground">
          Create and manage your organization's online presence
        </p>
      </div>

      {/* Microsite Features redesigned to match Key Features layout */}
      <Card className="bg-green-50 border-green-200">
        <CardHeader>
        </CardHeader>
        <CardContent>
          <div className="mb-2">
            <h2 className="text-xl font-semibold mb-1">Your Opportunities, Live, Up-to-Date, Sharable & Bookable</h2>
            <p className="text-muted-foreground mb-5">Send a single link instead of multiple PDFs. Your Mission Hub microsite makes sharing easy and professional.</p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Link className="h-5 w-5 text-green-600 mt-1" />
                <span>One link for all your opportunities—corporate & community.</span>
              </li>
              <li className="flex items-start gap-3">
                <RefreshCw className="h-5 w-5 text-green-600 mt-1" />
                <span>Real-time event updates—no outdated listings.</span>
              </li>
              <li className="flex items-start gap-3">
                <Brush className="h-5 w-5 text-green-600 mt-1" />
                <span>Custom branding to reflect your nonprofit’s identity.</span>
              </li>
              <li className="flex items-start gap-3">
                <Smartphone className="h-5 w-5 text-green-600 mt-1" />
                <span>Mobile-friendly and optimized for easy access.</span>
              </li>
              <li className="flex items-start gap-3">
                <Share2 className="h-5 w-5 text-green-600 mt-1" />
                <span>Live & Always Updated and Shareable</span>
              </li>
            </ul>
          </div>
        </CardContent>
      </Card>

      {/* Microsite management sections below features */}
      <div className="space-y-10 mt-10">
        {/* NPOMicrosite Section */}
        <NPOMicrosite profile={profile} session={session} />
        {/* MissionHubContentPage Section */}
        <MissionHubContentPage profile={profile} session={session} />
      </div>
    </div>
  );
};

export default MyWebsitePage;
